import Reveal from "./Reveal";

const DOUBTS = [
    { q: "Betul ke sekarang masa untuk BUY?", tone: "text-flame", blob: "bg-blood/15", tag: "PERSOALAN 01" },
    { q: "Patut tunggu confirmation dulu ke?", tone: "text-volt", blob: "bg-volt/15", tag: "PERSOALAN 02" },
    { q: "Macam mana nak tahu trend masih valid?", tone: "text-chrome", blob: "bg-white/10", tag: "PERSOALAN 03" },
];

const Problem = () => (
    <section data-testid="problem-section" className="relative py-24 md:py-32">
        <div className="pointer-events-none absolute right-0 top-40 h-[400px] w-[400px] rounded-full bg-volt/10 blur-3xl" />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <Reveal>
                <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-flame">
                    Realiti trader
                </p>
                <h2 className="mt-5 max-w-4xl font-display text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl md:text-6xl">
                    DAH TAHU TEKNIK, TAPI MASIH{" "}
                    <span className="text-chrome-grad">CONFUSE</span> BILA NAK
                    ENTRY?
                </h2>
            </Reveal>

            <Reveal delay={0.1}>
                <p className="mt-8 max-w-2xl leading-relaxed text-white/70">
                    Kadang-kadang bukan sebab teknik yang digunakan tak sesuai.
                    Tapi bila tengok chart, masih tertanya-tanya...
                </p>
            </Reveal>

            <div className="mt-12 flex flex-col gap-4 md:flex-row md:gap-6">
                {DOUBTS.map((d, i) => (
                    <Reveal
                        key={d.tag}
                        delay={0.12 * i}
                        className="flex-1"
                    >
                        <div
                            data-testid={`problem-card-${i + 1}`}
                            className="card-luxe group relative overflow-hidden rounded-3xl p-6 transition duration-300 hover:-translate-y-1 hover:border-white/20 md:p-7"
                        >
                            <div
                                className={`pointer-events-none absolute -right-10 -top-10 h-32 w-32 rounded-full ${d.blob} blur-2xl`}
                            />
                            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-white/40">
                                {d.tag}
                            </p>
                            <p
                                className={`mt-4 font-display text-lg font-bold leading-snug md:text-xl ${d.tone}`}
                            >
                                “{d.q}”
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.1}>
                <div className="mt-14 max-w-3xl space-y-5 leading-relaxed text-white/70">
                    <p>
                        Sebenarnya, trading bukan sekadar mengenal pasti
                        pattern.
                    </p>
                    <p>
                        Timing, confirmation dan money management juga
                        memainkan peranan penting.
                    </p>
                    <p className="border-l-2 border-blood pl-6 font-medium text-white">
                        Sebab tu dalam Engulf Summit kali ni, kita akan
                        breakdown bagaimana nak memahami dan menggunakan teknik
                        Engulfing dengan lebih teratur.
                    </p>
                </div>
            </Reveal>
        </div>
    </section>
);

export default Problem;
